'use strict';
const calculateLayout = require('@mindmup/mapjs-core/src/layout/calculate-layout'),
	LayoutModel = require('@mindmup/mapjs-core/src/layout/layout-model'),
	ThemeProvider = require('@mindmup/mapjs-core/src/theme/theme-provider'),
	NodeViewModel = require('@mindmup/mapjs-core/src/layout/node-view-model'),
	ActiveContentProvider = require('@mindmup/mapjs-core/src/content/active-content-provider'),
	connectorPath = require('@mindmup/mapjs-core/src/theme/connector'),
	linkPath = require('@mindmup/mapjs-core/src/theme/link'),
	svgMarkupBuilder = require('./markup-builder').svgMarkupBuilder,
	writeConnector = require('./write-connector'),
	writeConnectorLabel = require('./write-connector-label'),
	connectorBox = require('@mindmup/mapjs-core/src/layout/connector-box'),
	writeLink = require('./write-link'),
	writeNode = require('./write-node'),
	buildContentProvider = function (idea) {
		const activeContentProvider = new ActiveContentProvider();
		activeContentProvider.initializeSession('local', idea, []);
		return activeContentProvider;
	},
	buildNodeViewModel = function (themeProvider, activeContentProvider, textEngine, labels) {
		const nodeViewModel = new NodeViewModel(themeProvider, activeContentProvider, textEngine.nodeTextDimensions, {passive: true});
		nodeViewModel.setLabelGenerator(() => labels);
		return nodeViewModel;
	};
module.exports = function generateSVG(idea, textEngine, stickersEngine, options) {
	if (!idea || !textEngine || !stickersEngine
		|| !textEngine.nodeTextDimensions || !textEngine.writeNodeText || !textEngine.writeLine  || !textEngine.lineSize
		|| !stickersEngine.writeStickers) {
		throw new Error('invalid-args');
	}
	const activeContentProvider = buildContentProvider(idea),
		themeProvider = new ThemeProvider(activeContentProvider),
		nodeViewModel = buildNodeViewModel(themeProvider, activeContentProvider, textEngine, idea.labels),
		mapTheme = themeProvider.getTheme(),
		backgroundColor =  idea?.export?.imageBackground || mapTheme.canvasTheme().backgroundColor,
		backGroundIcon  =  mapTheme.canvasTheme().icon,
		layout = (options && options.layout) || calculateLayout(idea, i => nodeViewModel.getNodeViewForIdea(i).metrics, {theme: mapTheme}),
		initLayoutModel = function () {
			const result = new LayoutModel();
			result.setLayout(layout);
			return result;
		},
		layoutModel = initLayoutModel(),
		defaultCenter = Object.values(idea.ideas)[0],
		clipRect = layoutModel.clipRectTransform(defaultCenter.id, options),
		svg =  svgMarkupBuilder('svg').attr({
			'xmlns:xlink': 'http://www.w3.org/1999/xlink',
			'width': clipRect.width,
			'height': clipRect.height
		}),
		getConnectorBox = function (nodeId) {
			return connectorBox(layoutModel.getNode(nodeId), nodeViewModel.getNodeViewForIdeaId(nodeId));
		},
		scaleTransform = clipRect.scale !== 1 ? 'scale(' + clipRect.scale + ') ' : '',
		g = svgMarkupBuilder('g').attr('transform', scaleTransform + 'translate(' + clipRect.x + ',' + clipRect.y + ')').css({fill: 'none'}),
		defs = svgMarkupBuilder('defs').appendTo(svg),
		markers = {},
		buildArrowMarker = ({color, id, arrowLength, arrowWidth, arrowType}) => {
			if (!color || !id || !arrowLength || !arrowWidth || !arrowType) {
				throw new Error('invalid-args');
			}

			const refX = arrowType === 'from' ? arrowLength : 0,
				toPath = `M 0 0 L ${arrowLength} ${arrowWidth / 2} L 0 ${arrowWidth} z`,
				fromPath = `M ${arrowLength} 0 L 0 ${arrowWidth / 2} L ${arrowLength} ${arrowWidth} z`, // M 5 0 L 0 5 L 5 10 z
				d = arrowType === 'from' ? fromPath : toPath,
				marker = svgMarkupBuilder('marker')
				.appendTo(defs)
				.attr({
					id,
					viewBox: `0 0 ${arrowLength} ${arrowWidth}`,
					refX: String(refX),
					refY: String(arrowWidth / 2),
					markerUnits: 'userSpaceOnUse',
					markerWidth: String(arrowLength),
					markerHeight: String(arrowWidth),
					orient: 'auto' //librsvg did not support auto-start-reverse, so we need different arrows. https://gitlab.gnome.org/GNOME/librsvg/-/issues/484
				});
			svgMarkupBuilder('path')
				.appendTo(marker)
				.attr({
					d,
					fill: color
				});
			return marker;
		},
		getArrowMarkerId  = ({arrow, color, width, arrowExtension, theme}, arrowType) => {
			if (!arrow || (theme && theme.type === 'no-connector')) {
				return false;
			}
			if (!arrowExtension || !width || !color) {
				throw new Error('invalid-args');
			}
			const arrowLength = arrowExtension.length + width, // 5
				arrowWidth = arrowExtension.width + width, // 10
				id = 'arrow-' + arrowType + '-' + String(arrowLength) + '-' + String(arrowWidth) + '-' + color.replace(/#/, '');
			if (!markers[id]) {
				markers[id] = buildArrowMarker({color, id, arrowLength, arrowWidth, arrowType});
			}
			return id;
		},
		hasArrowType = (arrowTypeRequired, arrowType) => {
			return ['both', arrowTypeRequired].includes(arrowType);
		};

	if (options.additionalNamespaces) {
		svg.attr(options.additionalNamespaces);
	}
	if (options.additionalCss) {
		defs.append(
			svgMarkupBuilder('style').attr('type', 'text/css').cdata(options.additionalCss)
		);
	}
	if (backGroundIcon?.url) {
		const horizontalTilePct = (backGroundIcon.width * 100 / clipRect.width).toFixed(2),
			verticalTilePct = (backGroundIcon.height * 100 / clipRect.height).toFixed(2);
		defs.append(
			svgMarkupBuilder('pattern').attr({id: 'canvasImg', patternUnits: 'userSpaceOnUse', x: 0, y: 0, width: `${horizontalTilePct}%`, height: `${verticalTilePct}%`})
			.append(svgMarkupBuilder('image').attr({'xlink:href': backGroundIcon?.url, width: backGroundIcon.width, height: backGroundIcon.height, x: 0, y: 0}))
		);
		svgMarkupBuilder('rect').attr({
			width: '100%',
			height: '100%',
			fill: 'url(#canvasImg)'
		}).appendTo(svg);
	} else if (backgroundColor !== 'transparent') {
		svgMarkupBuilder('rect').attr({
			width: '100%',
			height: '100%',
			fill: backgroundColor
		}).appendTo(svg);
	}
	g.appendTo(svg);
	Object.values(layout.connectors).forEach(connector => {
		const toBox = getConnectorBox(connector.to),
			fromBox = getConnectorBox(connector.from),
			connectorProperties = connectorPath(fromBox, toBox, connector.attr, mapTheme),
			fromArrowMarkerId = hasArrowType('from', connectorProperties.arrow) ? getArrowMarkerId(connectorProperties, 'from') : null,
			toArrowMarkerId = hasArrowType('to', connectorProperties.arrow) ? getArrowMarkerId(connectorProperties, 'to') : null;
		g.append(writeConnector(connectorProperties, fromArrowMarkerId, toArrowMarkerId));
	});
	Object.values(layout.links).forEach(link => {
		const linkAttr = (link.attr && link.attr.style) || {},
			toBox = getConnectorBox(link.ideaIdTo),
			fromBox = getConnectorBox(link.ideaIdFrom),
			pathInfo = linkPath(fromBox, toBox, linkAttr, mapTheme);
		g.append(writeLink(pathInfo));
	});
	Object.values(layout.connectors).forEach(connector => {
		const toBox = getConnectorBox(connector.to),
			fromBox = getConnectorBox(connector.from),
			connectorProperties = connectorPath(fromBox, toBox, connector.attr, mapTheme);
		if (connectorProperties.label) {
			g.append(writeConnectorLabel(connectorProperties, fromBox, toBox, textEngine));
		}
	});
	Object.values(layout.links).forEach(link => {
		const linkAttr = (link.attr && link.attr.style) || {},
			toBox = getConnectorBox(link.ideaIdTo),
			fromBox = getConnectorBox(link.ideaIdFrom),
			pathInfo = linkPath(fromBox, toBox, linkAttr, mapTheme);
		if (linkAttr.label) {
			pathInfo.label = linkAttr.label;
			g.append(writeConnectorLabel(pathInfo, fromBox, toBox, textEngine));
		}

	});

	Object.values(layout.nodes).forEach(node => {
		const offsetX = (node.x + clipRect.x),
			offsetY = (node.y + clipRect.y);

		if (offsetX + node.width >= 0 && offsetX <= clipRect.width / clipRect.scale  && offsetY + node.height >= 0 && offsetY <= clipRect.height / clipRect.scale) {
			g.append(writeNode(node, nodeViewModel.getNodeViewForIdeaId(node.id), textEngine, stickersEngine));
		}

	});
	return svg.serialize();
};
